import { FooterSunpoint } from './FooterSunpoint'

export default FooterSunpoint
